import { ReactNode, Suspense, useEffect } from 'react'
import { useOutlet, useParams } from 'react-router'

import { Header } from './components/Header'
import { PersistentStateManager } from './state/persistentState'
import { FlowContext, FlowContextProvider } from './utils/FlowContext'
import { StagingStateHelper } from 'components/Header/StagingStateHelper'
import Loader from 'components/Loader'
import { ScrollToTop } from 'components/ScrollToTop'

import { CoreDirectFlowService } from 'app/CoreDirectFlowService'
import { CoreQuoteService } from 'app/CoreQuoteService'
import { QuoteStoreProvider } from 'src/store/QuoteStoreProvider'
import { initAnalytics } from 'utils'

const Wrapper = ({ flowContext, children }: { flowContext: FlowContext; children: ReactNode }) => {
  return (
    <Suspense fallback={<Loader />}>
      <FlowContextProvider value={flowContext}>
        <QuoteStoreProvider>
          <PersistentStateManager>
            <Header />
            <ScrollToTop>{children}</ScrollToTop>
          </PersistentStateManager>
        </QuoteStoreProvider>
      </FlowContextProvider>
    </Suspense>
  )
}

const DirectAnalyticsWrapper = ({ children }: { children: ReactNode }) => {
  const { quoteId } = useParams<{ quoteId: string }>()

  if (!quoteId) {
    throw new Error('Route does not have quote ID')
  }

  useEffect(() => {
    initAnalytics(quoteId, undefined)
  }, [quoteId])
  return <>{children}</>
}

export const DirectFlow = () => {
  const outlet = useOutlet()

  return (
    <CoreDirectFlowService>
      <DirectAnalyticsWrapper>
        <Wrapper flowContext={FlowContext.DIRECT}>
          <StagingStateHelper />
          {outlet}
        </Wrapper>
      </DirectAnalyticsWrapper>
    </CoreDirectFlowService>
  )
}

export const PostQuoteEdit = () => {
  const outlet = useOutlet()

  return (
    <Suspense fallback={<Loader />}>
      <FlowContextProvider value={FlowContext.POST_QUOTE}>
        <CoreQuoteService>
          <QuoteStoreProvider>
            <PersistentStateManager>
              <Header />
              <ScrollToTop>{outlet}</ScrollToTop>
            </PersistentStateManager>
          </QuoteStoreProvider>
        </CoreQuoteService>
      </FlowContextProvider>
    </Suspense>
  )
}
